export const POSTCODE_IN_SERACH_MODE_REQUIRED_ERROR_MESSAGE = 'Please enter a postcode and use the address lookup';
export const SEARCH_HAS_NOT_STARTED_WARNING_MESSAGE = 'Please use the address lookup';